export const semanticBaseDesignTokens = {
  transitionDuration: '0.2s',
  focusRing: {
    width: '1px',
    style: 'solid',
    color: '{primary.color}',
    offset: '2px',
    shadow: 'none',
  },
  disabledOpacity: '1',
  iconSize: '1rem',
  anchorGutter: '2px',
  primary: {
    50: '{blue.50}',
    100: '{blue.100}',
    200: '{blue.200}',
    300: '{blue.300}',
    400: '{blue.400}',
    500: '{blue.500}',
    600: '{blue.600}',
    700: '{blue.700}',
    800: '{blue.800}',
    900: '{blue.900}',
    950: '{blue.950}',
  },
  formField: {
    paddingX: '0.5rem',
    paddingY: '0.5rem',
    // for small elements:
    // sm: {
    //   fontSize: '0.875rem',
    //   paddingX: '0.625rem',
    //   paddingY: '0.375rem',
    // },
    // for large elements:
    // lg: {
    //   fontSize: '0.875rem',
    //   paddingX: '0.625rem',
    //   paddingY: '0.375rem',
    // },
    borderRadius: '0.5rem',
    focusRing: {
      width: '0',
      style: 'none',
      color: 'transparent',
      offset: '0',
      shadow: 'none',
    },
    transitionDuration: '{transition.duration}',
  },
  // configure this in future
  list: {
    padding: '0.25rem 0.25rem',
    gap: '2px',
    header: {
      padding: '0.5rem 1rem 0.25rem 1rem',
    },
    option: {
      padding: '0.5rem 0.75rem',
      borderRadius: '{border.radius.sm}',
    },
    optionGroup: {
      padding: '0.5rem 0.75rem',
      fontWeight: '600',
    },
  },
  // configure this in future
  content: {
    borderRadius: '{border.radius.md}',
  },
  mask: {
    transitionDuration: '0.15s',
  },
  // configure this in future
  navigation: {
    list: {
      padding: '0.25rem 0.25rem',
      gap: '2px',
    },
    item: {
      padding: '0.5rem 0.75rem',
      borderRadius: '{border.radius.sm}',
      gap: '0.5rem',
    },
    submenuLabel: {
      padding: '0.5rem 0.75rem',
      fontWeight: '600',
    },
    submenuIcon: {
      size: '0.875rem',
    },
  },
  // configure this in future
  overlay: {
    select: {
      borderRadius: '{border.radius.md}',
      shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
    },
    popover: {
      borderRadius: '{border.radius.md}',
      padding: '0.75rem',
      shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
    },
    modal: {
      borderRadius: '{border.radius.xl}',
      padding: '1.25rem',
      shadow: '0 20px 25px -5px rgba(0, 0, 0, 0.1), 0 8px 10px -6px rgba(0, 0, 0, 0.1)',
    },
    navigation: {
      shadow: '0 4px 6px -1px rgba(0, 0, 0, 0.1), 0 2px 4px -2px rgba(0, 0, 0, 0.1)',
    },
  },
  colorScheme: {
    light: {
      surface: {
        0: '#ffffff',
        50: '{sky.50}',
        100: '{sky.100}',
        200: '{sky.200}',
        300: '{sky.300}',
        400: '{sky.400}',
        500: '{sky.500}',
        600: '{sky.600}',
        700: '{sky.700}',
        800: '{sky.800}',
        900: '{sky.900}',
        950: '{sky.950}',
      },
      primary: {
        color: '{primary.500}',
        contrastColor: '#ffffff',
        hoverColor: '{primary.700}',
        activeColor: '{primary.700}',
      },
      // configure this in future
      highlight: {
        background: '{primary.50}',
        focusBackground: '{primary.100}',
        color: '{primary.700}',
        focusColor: '{primary.800}',
      },
      // configure this in future
      mask: {
        background: 'rgba(0,0,0,0.4)',
        color: '{surface.200}',
      },
      formField: {
        color: '{gray.950}',
        background: '{surface.0}',
        borderColor: '{primary.50}',
        hoverBorderColor: '{primary.50}',
        focusBorderColor: '{surface.500}',
        filledBackground: '{surface.0}',
        filledHoverBackground: '{surface.0}',
        filledFocusBackground: '{surface.0}',
        invalidBorderColor: '{red.500}',
        invalidPlaceholderColor: '{gray.950}',
        disabledColor: '{gray.200}',
        disabledBackground: '{gray.50}',
        placeholderColor: '{gray.300}',
        floatLabelColor: '{primary.300}',
        floatLabelFocusColor: '{primary.300}',
        floatLabelActiveColor: '{primary.300}',
        floatLabelInvalidColor: '{primary.300}',
        iconColor: '{gray.200}',
        // configure this in future
        shadow: '0 0 #0000, 0 0 #0000, 0 1px 2px 0 rgba(18, 18, 23, 0.05)',
      },
      // configure this in future
      text: {
        color: '{surface.500}',
        hoverColor: '{surface.600}',
        mutedColor: '{surface.300}',
        hoverMutedColor: '{surface.500}',
      },
      // configure this in future
      content: {
        background: '{surface.0}',
        hoverBackground: '{surface.500}',
        borderColor: '{primary.200}',
        color: '{text.color}',
        hoverColor: '{text.hover.color}',
      },
      // configure this in future
      overlay: {
        select: {
          background: '{surface.0}',
          borderColor: '{surface.200}',
          color: '{text.color}',
        },
        // configure this in future
        popover: {
          background: '{surface.0}',
          borderColor: '{surface.200}',
          color: '{text.color}',
        },
        // configure this in future
        modal: {
          background: '{surface.0}',
          borderColor: '{surface.200}',
          color: '{text.color}',
        },
      },
      // configure this in future
      list: {
        option: {
          focusBackground: '{surface.500}',
          selectedBackground: '{highlight.background}',
          selectedFocusBackground: '{highlight.focus.background}',
          color: '{text.color}',
          focusColor: '{text.hover.color}',
          selectedColor: '{highlight.color}',
          selectedFocusColor: '{highlight.focus.color}',
          icon: {
            color: '{surface.400}',
            focusColor: '{surface.500}',
          },
        },
        optionGroup: {
          background: 'transparent',
          color: '{text.muted.color}',
        },
      },
      // configure this in future
      navigation: {
        item: {
          focusBackground: '{surface.400}',
          activeBackground: '{surface.500}',
          color: '{text.color}',
          focusColor: '{text.hover.color}',
          activeColor: '{text.hover.color}',
          icon: {
            color: '{surface.400}',
            focusColor: '{surface.500}',
            activeColor: '{surface.500}',
          },
        },
        submenuLabel: {
          background: 'transparent',
          color: '{text.muted.color}',
        },
        submenuIcon: {
          color: '{surface.400}',
          focusColor: '{surface.500}',
          activeColor: '{surface.500}',
        },
      },
    },
  },
};
